import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  MESSAGE_BOX_VARIANT_NAMES,
  MessageBoxVariant,
  PROGRESS_BAR_VARIANT_NAMES,
  ProgressBarWidgetVariant,
  QUANTITY_BUTTONS_VARIANT_NAMES,
  QuantityButtonsVariant,
  WidgetType,
} from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

const ComponentVariantNameMap = {
  ...PROGRESS_BAR_VARIANT_NAMES,
  ...QUANTITY_BUTTONS_VARIANT_NAMES,
  ...MESSAGE_BOX_VARIANT_NAMES,
};

interface GlobalStylesHeaderProps {
  variantStyle:
    | MessageBoxVariant
    | ProgressBarWidgetVariant
    | QuantityButtonsVariant;
  widgetType: WidgetType;
}

export const GlobalStylesHeader = ({
  variantStyle,
  widgetType,
}: GlobalStylesHeaderProps) => {
  const theme = useTheme();
  return (
    <Grid item container direction={"column"} rowSpacing={0}>
      <Grid item>
        <IgTypography variant={"h3"} fontWeight={600}>
          {widgetType === "shippingProgressBar"
            ? "Shipping progress bar"
            : widgetType === "discountProgressBar"
              ? "Offer progress bar"
              : widgetType === "quantityButtons"
                ? "Quantity buttons"
                : "Offer message"}
        </IgTypography>
      </Grid>
      <Grid item>
        <IgTypography color={theme.palette.text.secondary}>
          {
            ComponentVariantNameMap[
              variantStyle || "quantityButtonsWidgetClassic"
            ]
          }
        </IgTypography>
      </Grid>
    </Grid>
  );
};
